import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output, inject } from '@angular/core';
import { Storage, getDownloadURL, ref } from '@angular/fire/storage';
import { FormsModule } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth.service';
import { ConfirmMenuService } from 'src/app/shared/services/confirm-menu/confirm-menu.service';
import { AppCalendarService } from 'src/app/views/event/app-calendar/app-calendar.service';
import { MySpaceService } from 'src/app/views/my-space/my-space.service';
import { environment } from 'src/environments/environment';
import { RoleSelectorComponent } from '../../components/role-selector/role-selector.component';
import { DiscreetSelectComponent, DiscreetSelectOption } from '../../components/ui/discreet-select/discreet-select.component';
import { UserComponent } from '../../components/ui/user/user.component';
import { UserGroupSearchComponent } from '../../components/user-group-search/user-group-search.component';
import { TenantService } from '../tenant/tenant.service';
import { TenantBrandingService } from '../tenant-branding/tenant-branding.service';
import { SkillztankCalendarEvent } from '../../models/event.model';
import { AppConfirmService } from '../app-confirm/app-confirm.service';
import { DynamicOverlayService } from '../dynamic-overlay/dynamic-overlay.service';
import { ColorPaletteOverlayComponent, ColorPaletteOverlayData } from '../../components/ui/color-palette-overlay/color-palette-overlay.component';

@Component({
  selector: 'app-share-menu',
  templateUrl: './share-menu.component.html',
  styleUrls: ['./share-menu.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    UserComponent,
    DiscreetSelectComponent,
    UserGroupSearchComponent,
    MatTooltipModule,
    RoleSelectorComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
  ],
})
export class ShareMenuComponent implements OnInit, OnDestroy {
  private readonly snackbar = inject(MatSnackBar);
  private confirmMenuService = inject(ConfirmMenuService);
  private dynamicOverlayService = inject(DynamicOverlayService);
  private tenantService = inject(TenantService);
  private tenantBrandingService = inject(TenantBrandingService);
  courseID;
  sectionID;
  lectureID;
  templateID;
  blogID;
  contentId;
  questionID;
  pathID;
  users = [];
  recentlyAddedList = [];
  public privateValue: any = false;
  public shareToken: string | null = null;
  public shareExpirationDate: string | null = null;
  public shareAllowDownload = false;
  public linkCopied = false;
  public showEmbedSection = false;
  public showAdvancedSection = false;
  public embedMode: 'full' | 'partial' = 'full';
  public sharePrimaryColor = '';
  public shareLogoUrl = '';
  public shareReturnUrl = '';
  public embedLang: '' | 'fr' | 'en' = '';
  public embedCodeCopied = false;
  public shareApprovedViewers: string[] = [];
  public sharePassword = '';
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  readonly embedColorPalette: string[] = [
    '#5a73c5', '#3b82f6', '#6366f1', '#8b5cf6', '#a855f7',
    '#ec4899', '#ef4444', '#f97316', '#eab308', '#22c55e',
    '#14b8a6', '#06b6d4', '#0ea5e9', '#64748b', '#1e293b',
  ];
  createModeSub: Subscription;
  createMode;
  loading = false;
  @Input() data;
  @Input() canEdit;
  @Output() userList = new EventEmitter<any>();
  displayedUsers;
  searchInput = '';

  privacyOptions: DiscreetSelectOption[] = [
    { viewValue: 'Public', value: false },
    { viewValue: 'Private', value: true },
  ];

  userTypes = {
    user: 'Utilisateur',
    group: 'Groupe',
  };
  filterTerm = '';
  storage;
  constructor(
    private authService: AuthService,
    private appService: AppService,
    private mySpaceService: MySpaceService,
    private confirmService: AppConfirmService,
    private translate: TranslateService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: any,
    private changeDetectorRef: ChangeDetectorRef,
    public calendarService: AppCalendarService
  ) {
    this.createModeSub = this.appService.createMode$.subscribe((createMode) => {
      this.createMode = createMode;
    });

    this.storage = inject(Storage);
    this.translate.onLangChange.subscribe(() => this.translateOptions());
  }

  ngOnInit() {
    this.data = this.data || this.dialogData || this.bottomSheetData;

    // NOTE : remember the type (course, section, lecture, blog)  is determined in the API depending on the presence or absence of the
    // following variables (at least one of these is undefined)
    this.courseID = this.data.courseID;
    this.sectionID = this.data.sectionID;
    this.lectureID = this.data.lectureID;
    this.blogID = this.data.blogID;
    this.templateID = this.data.templateID;
    this.questionID = this.data.questionID;
    this.pathID = this.data.pathID;

    this.translateOptions();

    if (this.data.isEvent) {
      this.getEventMembers(this.data.event);
    } else {
      this.getCurrentUsers();
    }
    this.users = this.data.users || [];
  }

  ngOnDestroy() {
    this.createModeSub.unsubscribe();
  }

  getPrivacyTooltip(): string {
    if (this.courseID) {
      if (this.privateValue === 'private') return 'ShareMenu.PrivacyTooltip.Private';
      if (this.privateValue === 'organization') return 'ShareMenu.PrivacyTooltip.Organization';
      return 'ShareMenu.PrivacyTooltip.Web';
    }
    return this.privateValue ? 'ShareMenu.PrivacyTooltip.Private' : 'ShareMenu.PrivacyTooltip.Public';
  }

  async getDownloadURL(url) {
    try {
      const reference = ref(this.storage, url);
      return await getDownloadURL(reference);
    } catch (error) {
      return 'assets/images/no_user.png';
    }
  }

  translateOptions() {
    if (this.courseID) {
      this.privacyOptions = [
        { viewValue: this.translate.instant('ShareMenu.Private'), value: 'private' },
        { viewValue: this.translate.instant('ShareMenu.Organization'), value: 'organization' },
        { viewValue: this.translate.instant('ShareMenu.Web'), value: 'web' },
      ];
    } else {
      this.privacyOptions = [
        { viewValue: this.translate.instant('ShareMenu.Public'), value: false },
        { viewValue: this.translate.instant('ShareMenu.Private'), value: true },
      ];
    }

    for (const key in this.userTypes) {
      this.userTypes[key] = this.translate.instant(`ShareMenu.${key}`);
    }
  }

  isRecentlyAdded(member) {
    return this.recentlyAddedList.find((user) => user === member._id);
  }

  getEmailOrType(member) {
    return member.email ? member.email : this.userTypes[member.type];
  }

  getEventMembers(event: SkillztankCalendarEvent) {
    this.loading = true;
    this.calendarService.getEventMembers(event._id).subscribe((res: any) => {
      this.users = res.users.map((user) => {
        const eventUser = event.users.find((e) => e.id === user.id) || {};
        user.userRole = eventUser.role;
        user.role = eventUser.role;
        user.type = eventUser.type;
        // user.image = user.photo || 'assets/images/no_user.png'
        user.name = user.firstName + ' ' + user.lastName;
        return user;
      });

      this.filterUsers();
      this.loading = false;
      this.changeDetectorRef.markForCheck();
    });
  }

  filterUsers() {
    this.displayedUsers = this.users.filter(
      (user) =>
        (user.name && user.name.toLowerCase().includes(this.filterTerm.toLowerCase())) || (user.email ? user.email.toLowerCase().includes(this.filterTerm.toLowerCase()) : true)
    );
    this.calendarService.updateNewEventUsers(this.displayedUsers);
    this.changeDetectorRef.markForCheck();
  }
  getRessourceData() {
    return {
      privateValue: undefined,
      courseID: this.courseID,
      sectionID: this.sectionID,
      lectureID: this.lectureID,
      templateID: this.templateID,
      userType: undefined,
      blogID: this.blogID,
      userID: undefined,
      userRole: undefined,
      questionID: this.questionID,
      pathID: this.pathID,
    };
  }

  get canAllowDownload(): boolean {
    return this.shareApprovedViewers && this.shareApprovedViewers.length > 0 && !!this.sharePassword && this.sharePassword.trim() !== '';
  }

  setPrivateValue() {
    this.loading = true;
    const data: any = this.getRessourceData();
    if (this.courseID) {
      data.shareLevel = this.privateValue;
      data.privateValue = this.privateValue === 'private';
      if (this.privateValue === 'web') {
        if (!this.canAllowDownload) {
          this.shareAllowDownload = false;
        }
        data.shareExpirationDate = this.shareExpirationDate || null;
        data.shareAllowDownload = this.shareAllowDownload;
        data.sharePrimaryColor = this.sharePrimaryColor || null;
        data.shareLogoUrl = this.shareLogoUrl || null;
        data.shareReturnUrl = this.shareReturnUrl || null;
        data.shareApprovedViewers = this.shareApprovedViewers;
        data.sharePassword = this.sharePassword || null;
      }
    } else {
      data.privateValue = this.privateValue;
    }
    this.mySpaceService.setPrivateValue(data).subscribe((res) => {
      this.getCurrentUsers();
    });
  }

  onExpirationDateChange(newDate: any) {
    if (newDate) {
      const date = newDate.toDate ? newDate.toDate() : new Date(newDate);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        this.shareExpirationDate = `${year}-${month}-${day}`;
      } else {
        this.shareExpirationDate = null;
      }
    } else {
      this.shareExpirationDate = null;
    }
    this.setPrivateValue();
  }

  get shareUrl(): string {
    const activeTenant = this.tenantService.activeTenantId() || 'app';
    const customDomain = this.tenantBrandingService.customDomain();
    if (customDomain && customDomain.trim() !== '') {
      return `https://${customDomain}/shared/${activeTenant}/${this.shareToken}`;
    }
    const fullSubdomain = this.tenantBrandingService.subdomain();
    if (fullSubdomain && fullSubdomain.trim() !== '') {
      return `https://${fullSubdomain}/shared/${activeTenant}/${this.shareToken}`;
    }
    const workspaceSlug = this.tenantBrandingService.workspaceSlug();
    if (workspaceSlug && workspaceSlug.trim() !== '' && workspaceSlug !== activeTenant) {
      const suffix = environment.domain;
      return `https://${workspaceSlug}.${suffix}/shared/${activeTenant}/${this.shareToken}`;
    }
    return window.location.origin + '/shared/' + activeTenant + '/' + this.shareToken;
  }

  copyLink() {
    const url = this.shareUrl;
    navigator.clipboard.writeText(url).then(() => {
      this.linkCopied = true;
      this.changeDetectorRef.markForCheck();
      setTimeout(() => {
        this.linkCopied = false;
        this.changeDetectorRef.markForCheck();
      }, 2000);
    });
  }

  get iframeCode(): string {
    let src = this.shareUrl;
    const params: string[] = [];
    if (this.embedMode === 'partial') params.push('mode=partial');
    if (this.embedLang) params.push('lang=' + this.embedLang);
    if (params.length) src += '?' + params.join('&');
    const dimensions = this.embedMode === 'partial' ? 'width="100%" height="600"' : 'width="100%" height="100%"';
    return `<iframe src="${src}" ${dimensions} frameborder="0" allowfullscreen></iframe>`;
  }

  copyEmbedCode() {
    navigator.clipboard.writeText(this.iframeCode).then(() => {
      this.embedCodeCopied = true;
      this.changeDetectorRef.markForCheck();
      setTimeout(() => {
        this.embedCodeCopied = false;
        this.changeDetectorRef.markForCheck();
      }, 2000);
    });
  }

  openColorPicker(event: Event) {
    const trigger = event.currentTarget as HTMLElement;
    const { ref: overlayRef, componentInstance } = this.dynamicOverlayService.open<ColorPaletteOverlayComponent, ColorPaletteOverlayData>(
      trigger,
      ColorPaletteOverlayComponent,
      { data: { colors: this.embedColorPalette } }
    );

    const sub = componentInstance.colorSelected.subscribe((color) => {
      this.dynamicOverlayService.close();
      this.sharePrimaryColor = color;
      this.changeDetectorRef.markForCheck();
      this.saveBranding();
    });

    overlayRef.detachments().subscribe(() => sub.unsubscribe());
  }

  isColorValid(): boolean {
    const color = (this.sharePrimaryColor || '').trim();
    if (!color) return true;
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color);
  }

  onColorInputBlur() {
    let color = (this.sharePrimaryColor || '').trim();
    if (color && !color.startsWith('#')) {
      if (/^[A-Fa-f0-9]{3}$|^[A-Fa-f0-9]{6}$/.test(color)) {
        color = '#' + color;
        this.sharePrimaryColor = color;
      }
    }
    if (this.isColorValid()) {
      this.saveBranding();
    }
  }

  saveBranding() {
    if (this.privateValue === 'web') {
      this.setPrivateValue();
    }
  }

  addApprovedViewer(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value && this.isValidEmail(value) && !this.shareApprovedViewers.includes(value)) {
      this.shareApprovedViewers.push(value);
      this.saveBranding();
    }
    event.chipInput!.clear();
  }

  removeApprovedViewer(email: string): void {
    const index = this.shareApprovedViewers.indexOf(email);
    if (index >= 0) {
      this.shareApprovedViewers.splice(index, 1);
      this.saveBranding();
    }
  }

  addViewerOnBlur(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    const value = (input.value || '').trim();
    if (value && this.isValidEmail(value) && !this.shareApprovedViewers.includes(value)) {
      this.shareApprovedViewers.push(value);
      input.value = '';
      this.saveBranding();
    }
  }

  private isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  regenerateLink(event: Event) {
    const target = event.currentTarget as HTMLElement;
    this.confirmMenuService.confirm(target, 'ShareMenu.Regenerate', 'check', 'primary', 'ShareMenu.RegenerateTitle', 'ShareMenu.ConfirmRegenerate').subscribe(() => {
      this.loading = true;
      const data: any = this.getRessourceData();
      data.shareLevel = this.privateValue;
      data.privateValue = this.privateValue === 'private';
      data.regenerateToken = true;
      data.shareExpirationDate = this.shareExpirationDate || null;
      data.shareAllowDownload = this.shareAllowDownload;
      this.mySpaceService.setPrivateValue(data).subscribe(() => {
        this.getCurrentUsers();
      });
    });
  }

  toggleAllowDownload(checked: boolean) {
    this.shareAllowDownload = checked;
    this.setPrivateValue();
  }

  readonly PASSWORD_PLACEHOLDER = '●●●●●●';
  sendingInvites = false;

  sendShareInvites() {
    if (!this.courseID || !this.sharePassword || this.sharePassword === this.PASSWORD_PLACEHOLDER || this.shareApprovedViewers.length === 0) {
      return;
    }

    this.sendingInvites = true;
    const shareLink = this.shareUrl;

    this.mySpaceService.sendShareInvites(this.courseID, this.sharePassword, shareLink).subscribe({
      next: () => {
        this.sendingInvites = false;
        this.snackbar.open(this.translate.instant('ShareMenu.InvitesSentSuccess'), 'OK', { duration: 3000 });
        this.changeDetectorRef.markForCheck();
      },
      error: (err) => {
        this.sendingInvites = false;
        this.snackbar.open(this.translate.instant('ShareMenu.InvitesSentError'), 'OK', { duration: 3000 });
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  editUser(memberID) {
    this.recentlyAddedList.push(memberID);
  }

  getCurrentUsers() {
    if (this.data.isEvent) {
      // this.users = []
      this.privateValue = false;
      return;
    }
    this.loading = true;
    this.mySpaceService.getRessourceUsers(this.getRessourceData()).subscribe((res) => {
      this.users = res.users.map((user) => {
        user.userRole = user.role;
        return user;
      });
      for (let i = 0; i < this.users.length; i++) {
        const user = this.users[i];
        if (user.photo !== 'null' && user.photo) {
          const actualFileName = user.photo.split(`/${environment.profilePictureBucketName}/`)[1];
          this.getDownloadURL(`gs://${environment.profilePictureBucketName}/${actualFileName}`)
            .then((photoLink) => {
              this.users[i].photo = photoLink;
            })
            .catch((err) => {
              console.error('ressource', err);
              user.photo = 'assets/images/no_user.png';
              console.error('error while getting profile photo link');
            });
        }
      }

      this.changeDetectorRef.markForCheck();
      this.filterUsers();
      if (this.courseID) {
        this.privateValue = res.shareLevel || (res.private ? 'private' : 'organization');
        this.shareToken = res.shareToken;
        this.shareExpirationDate = res.shareExpirationDate ? new Date(res.shareExpirationDate).toISOString().substring(0, 10) : null;
        this.shareAllowDownload = res.shareAllowDownload || false;
        this.sharePrimaryColor = res.sharePrimaryColor || '';
        this.shareLogoUrl = res.shareLogoUrl || '';
        this.shareReturnUrl = res.shareReturnUrl || '';
        this.shareApprovedViewers = res.shareApprovedViewers || [];
        this.sharePassword = res.sharePassword || '';
      } else {
        this.privateValue = res.private;
      }
      this.loading = false;
    });
  }

  highlight(element, word) {
    return element.replace(new RegExp(word, 'gi'), `<font color="red">${word}</font>`);
  }

  deleteUser(member) {
    if (this.data.isEvent) {
      this.calendarService.removeUsersInNewEvent(member);
      return;
    }
    const userID = member._id;
    this.confirmService.confirm({ message: this.translate.instant('Confirm.DeleteUser') }).subscribe((res) => {
      if (res) {
        const data = this.getRessourceData();
        data.userID = userID;
        this.mySpaceService.removeFromRessource(data).subscribe((res) => {
          this.getCurrentUsers();
        });
      }
    });
  }

  setUserRole(member, role) {
    if (this.data.isEvent) {
      const currentMemberIndex = this.calendarService.newEventUsersSource.value.findIndex((user) => user.id === member._id);
      this.calendarService.newEventUsersSource.value[currentMemberIndex].role = role;
      this.calendarService.updateNewEventUsers(this.calendarService.newEventUsersSource.value);
      return;
    }
    const data = this.getRessourceData();
    data.userID = member._id;
    data.userRole = role;
    console.log('data to send', data);
    this.mySpaceService.setUserRole(data).subscribe(() => {
      this.recentlyAddedList = this.recentlyAddedList.filter((user) => user !== data.userID);
      this.getCurrentUsers();
    });
  }

  addEntity(item) {
    const data: any = this.getRessourceData();
    const userType = item.class || item.type;
    data.userType = userType;
    data.userRole = 'Reader';
    data._id = item.id || item._id;

    if (this.data.isEvent) {
      data.email = item.email;
      data.name = item.name || item.fullName;
      data.role = 'Reader';
      data.type = data.userType;
      data.image = item.image;
      this.calendarService.addUsersInNewEvent(data);
    } else {
      const userId = item.id || item._id;
      data.userID = userId;
      data.name = item.name || item.fullName;
      data.email = item.email;
      this.mySpaceService.addToRessource(data).subscribe(() => {
        this.recentlyAddedList.push(userId);
        this.getCurrentUsers();
      });
    }
  }
  isPrivatizeOptionLocked() {
    const userID = this.authService.getID();
    if (this.questionID && this.data.asker !== userID) {
      return true;
    } else {
      return false;
    }
  }

  get windowLocationOrigin() {
    return window.location.origin;
  }
}

@Component({
  selector: 'app-role-picker',
  templateUrl: './role-picker.html',
  standalone: true,
  imports: [MatSelectModule, FormsModule, MatButtonModule, MatSelectModule, MatFormFieldModule],
})
export class RolePickerComponent {
  userTypes = ['Admin', 'Writer', 'Reader'];
  type = 'Reader';
  @Input() role;
  constructor(private dialogRef: MatDialogRef<RolePickerComponent>) {}

  selectType() {
    this.dialogRef.close(this.role);
  }
}
